import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"row"} }

import LearningItemForm from '@/components/learning/LearningItemForm.vue';
import LearningImportForm from '@/components/learning/LearningImportForm.vue';
import { Mutations, ShiftCMSState } from '@/store';
import { computed, markRaw, onBeforeUnmount, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { format } from 'date-fns';
import { LearningActions, LearningState } from '@/stores/learning.store';
import {
  LearningItem,
  LearningType,
  getLearningType,
} from '@/models/learning-item.model';
import { useEvents, Event } from '@/services/events.composable';
import TranslatedState from '../common/TranslatedState.vue';
import ListFilter from '../common/ListFilter.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LearningList',
  setup(__props) {

const store = useStore<ShiftCMSState & { les: LearningState }>();
const items = computed<LearningItem[]>(() => store.state.les.items);
const events = useEvents();

const update = () => {
  store.dispatch(LearningActions.GetLearningItems);
};

onMounted(() => {
  update();
  events.on(Event.LanguageChanged, update);
});

onBeforeUnmount(() => {
  store.commit(Mutations.HideDrawer);
  events.off(Event.LanguageChanged, update);
});

const editLearningItem = (_: Event, { item }: { item: LearningItem }) => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(LearningItemForm),
    data: item,
  });
};

const addLearningItem = () => {
  store.commit(Mutations.ShowDrawer, { component: markRaw(LearningItemForm) });
};
const importLearning = () => {
  store.commit(Mutations.ShowDrawer, {
    component: markRaw(LearningImportForm),
  });
};

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Title', key: 'title', width: '25%' },
  { title: 'Type', key: 'type', width: '15%' },
  { title: 'Category', key: 'mainCategory.title', width: '25%' },
  { title: 'Date', key: 'creationDate', width: '20%' },
  { title: 'State', key: 'translated', width: '10%' },
];

const filter = ref<string>('');
const filterTitle = ref<string>('');
const filteredItems = computed<LearningItem[]>(() => {
  return items.value.filter((v: LearningItem) => {
    if (filterTitle.value) {
      return [v.title, v.description, v.recommendation, v.type]
        .map((s) => s.toLowerCase())
        .join('')
        .includes(filterTitle.value);
    }
    if (filter.value) {
      return v.type === filter.value;
    }

    return true;
  });
});

function updateFilter(filters: { filter: string; filterTitle: string }) {
  filter.value = filters.filter;
  filterTitle.value = filters.filterTitle;

  console.log(filters.filter, filters.filterTitle);
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[4] || (_cache[4] = _createElementVNode("h2", null, "Learning Items", -1)),
      _createVNode(ListFilter, {
        dense: "",
        options: [
        { label: 'Article', value: _unref(LearningType).Article },
        { label: 'Book', value: _unref(LearningType).Book },
        { label: 'Building', value: _unref(LearningType).Building },
        { label: 'Experience', value: _unref(LearningType).Experience },
        { label: 'FaceBookGroup', value: _unref(LearningType).FaceBookGroup },
        { label: 'Influencer', value: _unref(LearningType).Influencer },
        { label: 'InstagramChannel', value: _unref(LearningType).InstagramChannel },
        { label: 'WebsiteOrApp', value: _unref(LearningType).WebsiteOrApp },
        { label: 'Movie', value: _unref(LearningType).Movie },
        { label: 'Podcast', value: _unref(LearningType).Podcast },
        { label: 'TEDTalk', value: _unref(LearningType).TEDTalk },
        { label: 'Visual', value: _unref(LearningType).Visual },
        { label: 'Video', value: _unref(LearningType).Video },
        { label: 'Other', value: _unref(LearningType).Other },
      ],
        onFilter: updateFilter
      }, null, 8, ["options"]),
      _createVNode(_component_v_data_table, {
        density: "compact",
        "onClick:row": editLearningItem,
        headers: headers,
        items: filteredItems.value,
        itemsPerPage: "25",
        hover: ""
      }, {
        "item.creationDate": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(_unref(format)(value, 'do MMMM yyyy - HH:mm')), 1)
        ]),
        "item.type": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(_unref(getLearningType)(value)), 1)
        ]),
        "item.translated": _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(TranslatedState, { item: item }, null, 8, ["item"]),
            _cache[0] || (_cache[0] = _createTextVNode("   ")),
            _createVNode(_component_v_tooltip, {
              text: 
              item.published
                ? 'This item is published'
                : 'This item is not published'
            
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_icon, _mergeProps(props, {
                  icon: item.published ? 'mdi-eye-check' : 'mdi-eye-outline',
                  color: item.published ? 'green' : 'red'
                }), null, 16, ["icon", "color"])
              ]),
              _: 2
            }, 1032, ["text"]),
            _cache[1] || (_cache[1] = _createTextVNode("   ")),
            _createVNode(_component_v_tooltip, { text: "This item is recommended" }, {
              activator: _withCtx(({ props }) => [
                (!!item.recommended)
                  ? (_openBlock(), _createBlock(_component_v_icon, _mergeProps({ key: 0 }, props, {
                      icon: "mdi-thumb-up-outline",
                      color: "primary"
                    }), null, 16))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ])
        ]),
        _: 1
      }, 8, ["items"]),
      _createVNode(_component_v_btn, {
        onClick: addLearningItem,
        color: "success"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("Add Learning Item")
        ])),
        _: 1
      }),
      _cache[5] || (_cache[5] = _createTextVNode("  ")),
      _createVNode(_component_v_btn, {
        onClick: importLearning,
        color: "primary"
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode("Import Learning Item")
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})